import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../state/refresh'
import { useRequests } from '../requests/useRequests'
import '../styles/auth.css'

const ActivateAccountPage = (): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const requestMaker = useRequests()

  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isActivated, setIsActivated] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const emailParam = searchParams.get('email')
    const codeParam = searchParams.get('code')
    
    if (emailParam) {
      setEmail(emailParam)
    }
    if (codeParam) {
      setCode(codeParam)
    }
  }, [searchParams])

  const handleActivation = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)

    if (!email || !code) {
      setError('Email i kod są wymagane')
      setIsLoading(false)
      return
    }

    try {
      await requestMaker.activateAccount(email, code)
      setIsActivated(true)
      dispatch(RefreshActions.setToastMessage({ message: 'Konto zostało pomyślnie aktywowane' }))
      
      // Przekieruj do logowania po 3 sekundach
      setTimeout(() => {
        navigate('/login')
      }, 3000)
    } catch (e: any) {
      if (e.status === 404) {
        setError('Użytkownik o podanym adresie email nie istnieje')
      } else if (e.status === 401) {
        setError('Nieprawidłowy kod aktywacyjny')
      } else if (e.status === 400) {
        setError('Kod aktywacyjny nie został znaleziony')
      } else {
        setError('Wystąpił błąd podczas aktywacji konta')
      }
    }

    setIsLoading(false)
  }

  const handleManualActivation = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)

    if (!email || !code) {
      setError('Email i kod są wymagane')
      setIsLoading(false)
      return
    }

    try {
      await requestMaker.activateAccount(email, code)
      setIsActivated(true)
      dispatch(RefreshActions.setToastMessage({ message: 'Konto zostało pomyślnie aktywowane' }))
      
      // Przekieruj do logowania po 3 sekundach
      setTimeout(() => {
        navigate('/login')
      }, 3000)
    } catch (e: any) {
      if (e.status === 404) {
        setError('Użytkownik o podanym adresie email nie istnieje')
      } else if (e.status === 401) {
        setError('Nieprawidłowy kod aktywacyjny')
      } else if (e.status === 400) {
        setError('Kod aktywacyjny nie został znaleziony')
      } else {
        setError('Wystąpił błąd podczas aktywacji konta')
      }
    }

    setIsLoading(false)
  }

  if (isActivated) {
    return (
      <div className='login-page-wrapper'>
        <div className='login-left-panel'>
          <img src='/assets/images/logo/logo-black.png' alt='kreatlo logo' className='login-logo' />
          <h2>Aktywacja konta zakończona pomyślnie!</h2>
          <p>
            Twoje konto zostało aktywowane. Za chwilę zostaniesz przekierowany do strony logowania.
          </p>
        </div>
        <div className='login-right-panel'>
          <div className='auth-container'>
            <h1 className='auth-title'>Konto aktywowane</h1>
            <div className='success-message'>
              <p>✅ Twoje konto zostało pomyślnie aktywowane!</p>
              <p>Możesz się teraz zalogować używając swojego adresu email i hasła.</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='login-page-wrapper'>
      <div className='login-left-panel'>
        <img src='/assets/images/logo/logo-black.png' alt='kreatlo logo' className='login-logo' />
        <h2>Aktywuj swoje konto w Kreatlo</h2>
        <p>
          Kliknij w link z emaila lub wprowadź kod aktywacyjny ręcznie.
        </p>
      </div>
      <div className='login-right-panel'>
        <div className='auth-container'>
          <h1 className='auth-title'>Aktywacja konta</h1>
          <p className='auth-description'>
            Sprawdź swoją skrzynkę email i kliknij w link aktywacyjny lub wprowadź kod ręcznie.
          </p>

          {email && code ? (
            <div className='auto-activation'>
              <p>Wykryto link aktywacyjny. Kliknij poniższy przycisk, aby aktywować konto.</p>
              <button
                type='button'
                className='btn-primary'
                onClick={handleActivation}
                disabled={isLoading}
              >
                {isLoading ? 'Aktywowanie...' : 'Aktywuj konto'}
              </button>
            </div>
          ) : (
            <form onSubmit={handleManualActivation} className='auth-form'>
              <div className='form-group'>
                <input
                  type='email'
                  className='form-control'
                  placeholder='Adres email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className='form-group'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Kod aktywacyjny'
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                />
              </div>

              {error && <div className='error-text'>{error}</div>}

              <button
                type='submit'
                className='btn-primary'
                disabled={isLoading}
              >
                {isLoading ? 'Aktywowanie...' : 'Aktywuj konto'}
              </button>
            </form>
          )}

          <div className='auth-footer'>
            <span className='footer-text'>Masz już aktywne konto?</span>
            <button className='register-link' onClick={() => navigate('/login')}>
              Zaloguj się <i className='fas fa-arrow-right' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActivateAccountPage 